import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Observable, timer } from 'rxjs';
import { throttle } from 'rxjs/operators';
import { fetchJson, StreamUtils, SyncOptions, StreamStateSubject } from '@ceramicnetwork/common';
import { StreamID } from '@ceramicnetwork/streamid';
import QueryString from 'query-string';
export var Document = /*#__PURE__*/function (_Observable) {
  _inherits(Document, _Observable);
  var _super = _createSuper(Document);
  function Document(initial, _apiUrl, syncInterval) {
    var _this;
    _classCallCheck(this, Document);
    _this = _super.call(this, function (subscriber) {
      var isFirstObserver = _this.state$.observers.length === 0;
      if (isFirstObserver) {
        _this.periodicSubscription = timer(0, syncInterval).pipe(throttle(function () {
          return _this._syncState(_this.id, {
            sync: SyncOptions.PREFER_CACHE
          });
        })).subscribe();
      }
      _this.state$.subscribe(subscriber).add(function () {
        var isNoObserversLeft = _this.state$.observers.length === 0;
        if (isNoObserversLeft) {
          var _this$periodicSubscri;
          (_this$periodicSubscri = _this.periodicSubscription) === null || _this$periodicSubscri === void 0 ? void 0 : _this$periodicSubscri.unsubscribe();
        }
      });
    });
    _this._apiUrl = _apiUrl;
    _this.state$ = new StreamStateSubject(initial);
    return _this;
  }
  _createClass(Document, [{
    key: "value",
    get: function get() {
      return this.state$.value;
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.value;
    }
  }, {
    key: "next",
    value: function next(state) {
      this.state$.next(state);
    }
  }, {
    key: "_syncState",
    value: function () {
      var _syncState2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(streamId, opts) {
        var state;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Document._load(streamId, this._apiUrl, opts);
            case 2:
              state = _context.sent;
              this.state$.next(StreamUtils.deserializeState(state));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _syncState(_x, _x2) {
        return _syncState2.apply(this, arguments);
      }
      return _syncState;
    }()
  }, {
    key: "id",
    get: function get() {
      return new StreamID(this.state$.value.type, this.state$.value.log[0].cid);
    }
  }, {
    key: "complete",
    value: function complete() {
      this.state$.complete();
    }
  }], [{
    key: "createFromGenesis",
    value: function () {
      var _createFromGenesis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(apiUrl, type, genesis, opts, syncInterval) {
        var _yield$fetchJson, state;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchJson(apiUrl + '/streams', {
                method: 'post',
                body: {
                  type: type,
                  genesis: StreamUtils.serializeCommit(genesis),
                  opts: opts
                }
              });
            case 2:
              _yield$fetchJson = _context2.sent;
              state = _yield$fetchJson.state;
              return _context2.abrupt("return", new Document(StreamUtils.deserializeState(state), apiUrl, syncInterval));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function createFromGenesis(_x3, _x4, _x5, _x6, _x7) {
        return _createFromGenesis.apply(this, arguments);
      }
      return createFromGenesis;
    }()
  }, {
    key: "applyCommit",
    value: function () {
      var _applyCommit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(apiUrl, streamId, commit, opts, syncInterval) {
        var _yield$fetchJson2, state;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchJson(apiUrl + '/commits', {
                method: 'post',
                body: {
                  streamId: streamId.toString(),
                  commit: StreamUtils.serializeCommit(commit),
                  opts: opts
                }
              });
            case 2:
              _yield$fetchJson2 = _context3.sent;
              state = _yield$fetchJson2.state;
              return _context3.abrupt("return", new Document(StreamUtils.deserializeState(state), apiUrl, syncInterval));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function applyCommit(_x8, _x9, _x10, _x11, _x12) {
        return _applyCommit.apply(this, arguments);
      }
      return applyCommit;
    }()
  }, {
    key: "_load",
    value: function () {
      var _load2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(streamId, apiUrl, opts) {
        var url, _yield$fetchJson3, state;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = apiUrl + '/streams/' + streamId.toString() + '?' + QueryString.stringify(opts);
              _context4.next = 3;
              return fetchJson(url);
            case 3:
              _yield$fetchJson3 = _context4.sent;
              state = _yield$fetchJson3.state;
              return _context4.abrupt("return", state);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function _load(_x13, _x14, _x15) {
        return _load2.apply(this, arguments);
      }
      return _load;
    }()
  }, {
    key: "load",
    value: function () {
      var _load3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(streamId, apiUrl, syncInterval, opts) {
        var state;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return Document._load(streamId, apiUrl, opts);
            case 2:
              state = _context5.sent;
              return _context5.abrupt("return", new Document(StreamUtils.deserializeState(state), apiUrl, syncInterval));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function load(_x16, _x17, _x18, _x19) {
        return _load3.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "loadStreamCommits",
    value: function () {
      var _loadStreamCommits = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(streamId, apiUrl) {
        var _yield$fetchJson4, commits;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetchJson("".concat(apiUrl, "/commits/").concat(streamId));
            case 2:
              _yield$fetchJson4 = _context6.sent;
              commits = _yield$fetchJson4.commits;
              return _context6.abrupt("return", commits.map(function (r) {
                return {
                  cid: r.cid,
                  value: StreamUtils.deserializeCommit(r.value)
                };
              }));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function loadStreamCommits(_x20, _x21) {
        return _loadStreamCommits.apply(this, arguments);
      }
      return loadStreamCommits;
    }()
  }]);
  return Document;
}(Observable);